import compact from 'lodash/compact';
const defaultKey = ['talent-comparison'];
const keys = {
    default: defaultKey,
    comparisonBehaviorAssesments: (behaviorType, targetType, targetId, params) => {
        return compact([
            ...defaultKey,
            'behavior',
            targetId,
            targetType,
            behaviorType,
            params
        ]);
    },
    sidebarBehaviorAssesments: (behaviorId, targetId, targetType, params) => {
        return compact([
            ...defaultKey,
            'behavior-sidebar',
            behaviorId,
            targetId,
            targetType,
            params
        ]);
    },
    comparatorEmployee: (params) => {
        return compact([...defaultKey, 'employee', params]);
    },
    comparatorGroup: (params) => {
        return compact([...defaultKey, 'group', params]);
    },
    comparisonGoalAssesments: (targetType, targetId, params) => {
        return compact([...defaultKey, targetType, targetId, params]);
    },
    comparisonGoalAssesmentsList: (targetType, targetId, params) => {
        return compact([
            ...defaultKey,
            'goal-assesments',
            targetType,
            targetId,
            params
        ]);
    },
    comparisonGoalAssesmentsDetail: (objectiveId) => {
        return compact([...defaultKey, 'goal-assesment', objectiveId]);
    },
    comparisonPerformanceAssesments: (targetId, targetType, cycleId, params) => {
        return compact([
            ...defaultKey,
            'performance',
            targetId,
            targetType,
            cycleId,
            params
        ]);
    },
    cycleSources: (params) => {
        return compact([...defaultKey, 'cycle-sources', params]);
    },
    comparisonCalibrationHistories: (cycleId, targetId, params) => {
        return compact([
            ...defaultKey,
            'calibration-histories',
            cycleId,
            targetId,
            params
        ]);
    }
};
export default keys;
